import { toast } from 'react-toastify';
import { ReajusteEstoque } from '../routes/RoutesNames';
import ReajusteEstoqueController from '../controllers/ReajusteEstoqueController';
import { useNavigate } from 'react-router';
import { useForm } from './useForm';
import { ReajusteEstoqueRequest } from '../controllers/Types';
import { useState } from 'react';

const useReajusteEstoqueCadastrar = (ReajusteEstoqueId?: number | null) => {

    const navigation = useNavigate();
    const [loading, setLoading] = useState<boolean>(false);
    const initialValues = {
        est_id: '',
        est_dataInc: new Date().toISOString().split('T')[0],
        prod_descricao: '',
        qtd_atual: null,
        qtd_real: null,
        diferenca: null,
        ocorrencia: ''
    };


    const handleSubmit = async (data: ReajusteEstoqueRequest) => {
        setLoading(true);

        // if (ReajusteEstoqueId) {
        //     const response = await ReajusteEstoqueController.Adicionar({
        //         est_id: ReajusteEstoqueId,
        //         prod_id: data.prod_id,
        //         qtd_real: data.qtd_real,
        //         qtd_atual: data.qtd_atual,
        //         diferenca: data.diferenca,
        //         responsavel: data.responsavel?.toUpperCase(),
        //         ocorrencia: data.ocorrencia,
        //         est_dataInc: data.est_dataInc,
        //     });

        //     if (response.StatusCode === 204) {
        //         toast('Reajuste de Estoque atualizado com sucesso!', {
        //             type: 'success',
        //         });
        //     }
        // } else {
        console.log('data', data);
        const response = await ReajusteEstoqueController.Adicionar({
            prod_id: data.prod_descricao?.prod_id,
            qtd_real: data.qtd_real,
            qtd_atual: data.qtd_atual,
            diferenca: data.diferenca,
            responsavel: data.responsavel?.cli_id,
            ocorrencia: data.ocorrencia,
            est_dataInc: data.est_dataInc,
        });

        if (response.StatusCode === 204 || response.StatusCode === 200) {
            toast('Reajuste de Estoque cadastrado com sucesso!', {
                type: 'success',
            });
        }
        navigation(ReajusteEstoque);
        //}

        toast.success('Erro ao cadastrar Reajuste de Estoque!', {
            type: 'error',
        });
        setLoading(false);
    }

    const form = useForm({
        onSubmit: handleSubmit,
        initialValues: initialValues,
       //validationSchema: ReajusteEstoqueSchema,
    });

    const handleSaveClick = () => {
        const formElement = document.querySelector('form');

        if (formElement) {
            formElement.dispatchEvent(
                new Event('submit', { cancelable: true, bubbles: true })
            );
        } else {
            console.error("Formulário não encontrado na tela");
        }
    };
 
    return {
        ...form,
        loading,
        initialValues,
        setLoading,
        handleSubmit,
        handleSaveClick
    }
}

export default useReajusteEstoqueCadastrar;

